import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useUpdateCandidateFilter = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.candidatesUpdateFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.candidatesFilters]);
    },
  });
};
